import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineSend } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
import { BiStopCircle, BiPlusCircle } from "react-icons/bi";
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import { IoRefresh } from "react-icons/io5";
import "../../../../styles/searchDetails.css";
import SyncFusionDateTimePicker from "../../SyncFusionDateTimePicker/SyncFusionDateTimePicker";

export const SearchDetails = (props) => {
  const { t } = useTranslation();

  return (
    <div className="sd-card">
      <div className="sd-bar">

        {/* ── Grupo esquerdo: label + datas + busca/atualizar ── */}
        <div className="sd-main">
          <span className="sd-label">{t("SEARCH.SEARCH")}</span>

          <div className="sd-date-field">
            <SyncFusionDateTimePicker
              id="datetimepickerStart"
              value={props.startDate}
              onChange={props.setStartDate}
              placeholder={t("SEARCH.INITIAL_DATE_TIME")}
              step={30}
              width="100%"
            />
          </div>

          <div className="sd-date-field">
            <SyncFusionDateTimePicker
              id="datetimepickerEnd"
              value={props.endDate}
              onChange={props.setEndDate}
              placeholder={t("SEARCH.FINAL_DATE_TIME")}
              step={30}
              width="100%"
            />
          </div>

          <div className="sd-actions-primary">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tt-search">{t("SEARCH.SEARCH")}</Tooltip>}
            >
              <button
                type="button"
                className="btn btn-outline-secondary sd-btn"
                onClick={() => props.search && props.search()}
              >
                <FaSearch size={14} className="sd-btn-icon" />
                <span className="sd-btn-label">{t("SEARCH.SEARCH")}</span>
              </button>
            </OverlayTrigger>

            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tt-refresh">{t("SEARCH.UPDATE_PAGE")}</Tooltip>}
            >
              <button
                type="button"
                className="btn btn-outline-secondary sd-btn"
                onClick={() => props.refresh()}
              >
                <IoRefresh size={16} className="sd-btn-icon" />
                <span className="sd-btn-label">{t("SEARCH.UPDATE")}</span>
              </button>
            </OverlayTrigger>
          </div>
        </div>

        {/* ── Divisor vertical ── */}
        <div className="sd-divider" />

        {/* ── Grupo direito: ações ── */}
        <div className="sd-actions-secondary">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tt-maintenance">
                {`${
                  props.underMaintenace === "S"
                    ? t("MAINTENANCE.REMOVE")
                    : t("MAINTENANCE.REGISTER")
                } ${t("MAINTENANCE.MAINTENANCE")}`}
              </Tooltip>
            }
          >
            <button
              type="button"
              className="btn btn-outline-secondary sd-btn"
              onClick={() => props.handleActiveMaintenace()}
            >
              {props.underMaintenace === "S" ? (
                <BiStopCircle size={16} className="sd-btn-icon" />
              ) : (
                <BiPlusCircle size={16} className="sd-btn-icon" />
              )}
              <span className="sd-btn-label">{t("MAINTENANCE.MAINTENANCE")}</span>
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tt-commands">{t("COMMANDS.SEND_COMMANDS")}</Tooltip>}
          >
            <button
              type="button"
              className="btn btn-outline-secondary sd-btn"
              onClick={() => props.handleShowCommands()}
            >
              <HiOutlineWrenchScrewdriver size={16} className="sd-btn-icon" />
              <span className="sd-btn-label">{t("COMMANDS.COMMANDS")}</span>
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tt-history">{t("COMMANDS.COMMAND_HISTORY")}</Tooltip>
            }
          >
            <button
              type="button"
              className="btn btn-outline-secondary sd-btn"
              onClick={() => props.handleActiveCommands()}
            >
              <AiOutlineSend size={16} className="sd-btn-icon" />
              <span className="sd-btn-label">{t("FLEET.HISTORY")}</span>
            </button>
          </OverlayTrigger>
        </div>

      </div>
    </div>
  );
};
